(function () {
  'use strict';

  if (window.__itslabubuKlaviyoAddedToCart) return;
  window.__itslabubuKlaviyoAddedToCart = true;

  var root = document.documentElement;
  var lastSignature = '';
  var lastTrackedAt = 0;
  if (root) root.dataset.klaviyoAtcBridge = 'ready';
  if (window.console && console.info) console.info('[ItsLabubu][Klaviyo] ATC bridge ready');

  function absoluteUrl(path) {
    try { return new URL(path || '/', window.location.origin).href; }
    catch (error) { return window.location.origin; }
  }

  document.addEventListener('product:added-to-cart', function (event) {
    var detail = event && event.detail ? event.detail : {};
    var variantId = Number(detail.id);
    var addedQuantity = Number(detail.quantity || 1);

    window.setTimeout(function () {
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed: ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        var items = Array.isArray(cart.items) ? cart.items : [];
        var addedItem = null;

        for (var index = items.length - 1; index >= 0; index -= 1) {
          if (Number(items[index].variant_id) === variantId) {
            addedItem = items[index];
            break;
          }
        }
        if (!addedItem) return;

        var now = Date.now();
        var signature = [cart.token || '', variantId, addedQuantity, items.length].join(':');
        if (signature === lastSignature && now - lastTrackedAt < 2000) return;
        lastSignature = signature;
        lastTrackedAt = now;

        var payload = {
          $event_id: signature + ':' + now,
          $source: 'ItsLabubu Shopify AJAX Cart',
          AddedItemProductName: addedItem.product_title || addedItem.title || '',
          AddedItemProductID: addedItem.product_id,
          AddedItemVariantID: addedItem.variant_id,
          AddedItemSKU: addedItem.sku || '',
          AddedItemImageURL: addedItem.image || '',
          AddedItemURL: absoluteUrl(addedItem.url),
          AddedItemPrice: Number(addedItem.final_price != null ? addedItem.final_price : addedItem.price || 0) / 100,
          AddedItemQuantity: addedQuantity,
          ItemNames: items.map(function (item) { return item.product_title || item.title || ''; }),
          CheckoutURL: absoluteUrl('/checkout'),
          Items: items.map(function (item) {
            return {
              ProductID: item.product_id,
              VariantID: item.variant_id,
              ProductName: item.product_title || item.title || '',
              Quantity: item.quantity,
              ItemPrice: Number(item.final_price != null ? item.final_price : item.price || 0) / 100,
              ImageURL: item.image || '',
              ProductURL: absoluteUrl(item.url)
            };
          })
        };

        window._learnq = window._learnq || [];
        window._learnq.push(['track', 'Added to Cart', payload]);
        if (root) root.dataset.klaviyoAtcLastEvent = payload.$event_id;
        if (window.console && console.info) {
          console.info('[ItsLabubu][Klaviyo] Added to Cart queued', payload.$event_id);
        }
      })
      .catch(function (error) {
        if (root) root.dataset.klaviyoAtcError = String(error && error.message || error);
        if (window.console && console.warn) {
          console.warn('[ItsLabubu][Klaviyo] Added to Cart tracking failed', error);
        }
      });
    }, 0);
  });
})();
